export const assignTicketConstants = {
  ASSIGNTICKET_POST: 'ASSIGNTICKET_POST',
  ASSIGNTICKET_SUCCESS: 'ASSIGNTICKET_SUCCESS',
  ASSIGNTICKET_ERROR: 'ASSIGNTICKET_ERROR',
  UNASSIGN_TICKET_POST: 'UNASSIGN_TICKET_POST',
  UNASSIGN_TICKET_SUCCESS: 'UNASSIGN_TICKET_SUCCESS',
  UNASSIGN_TICKET_ERROR: 'UNASSIGN_TICKET_ERROR',
};
